import {
  SESSION_CHECK_START,
  SESSION_CHECK_SUCCESS,
  SESSION_CHECK_FAILURE,
  SESSION_CLEAR,
  SESSION_SET,
  SESSION_RESET_CHECK,
} from "./sessionTypes";
import { isAuthenticated } from "../../helper/checkSession";

const initialState = {
  isValid: false,
  isLoading: true,
  lastChecked: null,
  hasChecked: false,
  isChecking: false,
  message: null,
  data: null,
};

const sessionReducer = (state = initialState, action) => {
  switch (action.type) {
    case SESSION_CHECK_START:
      return {
        ...state,
        isChecking: true,
      };

    case SESSION_CHECK_SUCCESS:
      return {
        ...state,
        isValid: action.payload.isValid,
        isLoading: false,
        isChecking: false,
        lastChecked: new Date().toISOString(),
        hasChecked: true,
        message: action.payload.message,
        data: action.payload.data,
      };

    case SESSION_CHECK_FAILURE:
      return {
        ...state,
        isValid: false,
        isLoading: false,
        isChecking: false,
        lastChecked: new Date().toISOString(),
        hasChecked: true,
        message: action.payload.message,
        data: null,
      };

    case SESSION_CLEAR:
      return {
        ...initialState,
        isLoading: false,
        hasChecked: true,
        lastChecked: new Date().toISOString(),
      };

    case SESSION_SET:
      return {
        ...state,
        // In this new flow, we don't manage token here
        isValid: true,
        hasChecked: true,
        lastChecked: new Date().toISOString(),
      };

    case SESSION_RESET_CHECK:
      return {
        ...state,
        hasChecked: false,
        lastChecked: null,
      };

    default:
      return state;
  }
};

export default sessionReducer;
